import { elakay_API } from "../../config";

export const previewSalesSimulation = async (inputs, signal, token) => {
  const headers = { Accept: "application/json", "Content-Type": "application/json" };
  // The route requires auth (see server_elakay/elakay_routes/product.js); without this
  // header every call 401s and the UI shows "The simulation could not be loaded."
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(`${elakay_API}/products/sales-simulation`, {
    method: "POST",
    headers,
    body: JSON.stringify(inputs),
    signal,
  });
  const result = await response.json();
  if (!response.ok || result.error) throw new Error(result.code || "SIMULATION_UNAVAILABLE");
  return result;
};
